export enum AuthResultEnum {
  Other = 0,
  Deactivated = 1,
  LockedOut = 2,
}
